import { CommonService, ReduxService } from 'dashboard-services/services';

import { basicCustomInsightConsts, inputParamsCustomInsightActions } from 'actions/modules/insight';

const remapScopeFilterValues = ({ presets, indexes }) => presets.map(preset => {
  const filterValues = preset[basicCustomInsightConsts.INPUT_PARAMS_SCOPE_PRESET_FIELDS.FILTER_VALUES]
  if(!filterValues) {
    return preset
  }
  const nextValues = Object.fromEntries(indexes.flatMap((previousIndex, index) => Object.prototype.hasOwnProperty.call(filterValues, previousIndex)
    ? [[index, filterValues[previousIndex]]]
    : []))
  return ReduxService.updateObject(preset, { [basicCustomInsightConsts.INPUT_PARAMS_SCOPE_PRESET_FIELDS.FILTER_VALUES]: nextValues })
})

export const inputParamsCustomReducer = (state , action) => {
  switch (action.type) {
    case inputParamsCustomInsightActions.DELETE_INPUT_PARAM:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: state.content?.inputParams.removeProp(action.inputId)
        })
      })
    case inputParamsCustomInsightActions.ON_REORDER_INPUT_PARAMS_LIST: {
      const inputConfig = state.content.inputParams[action.inputId],
            indexes = Array.from({ length: inputConfig[action.listName].length }, (_, index) => index).moveItem(action.from, action.to),
            presets = action.listName === 'values' && inputConfig.presets
              ? { presets: remapScopeFilterValues({ presets: inputConfig.presets, indexes }) }
              : {}
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: ReduxService.updateObject(state.content.inputParams, {
            [action.inputId]: ReduxService.updateObject(inputConfig, {
              [action.listName]: inputConfig[action.listName].moveItem(action.from, action.to),
              ...presets
            })
          }) 
        })
      })
    }
    case inputParamsCustomInsightActions.ADD_INPUT_PARAMS: {
      const id = CommonService.generateUID()
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: ReduxService.updateObject(state.content?.inputParams || {}, { 
            [id]: ReduxService.updateObject(basicCustomInsightConsts.EMPTY_INPUT_PARAMS, { 
              title: `Parameters ${(Object.values(state.content?.inputParams || {})).length + 1}` 
            })
          }),
        }),
        selectedTile: basicCustomInsightConsts.TILE_TYPES.INPUT_PARAMS + "-" + id,
        isActiveInputParamsOpen: true,
        activeInputParamsId: id
      })
    }
    case inputParamsCustomInsightActions.DUPLICATE_INPUT_PARAMS: {
      const id = CommonService.generateUID()
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: ReduxService.updateObject(state.content?.inputParams || {}, { 
            [id]: ReduxService.updateObject(state.content.inputParams[action.id], { 
              title: action.newTitle
            })
          }),
        }),
        selectedTile: basicCustomInsightConsts.TILE_TYPES.INPUT_PARAMS + "-" + id,
        isActiveInputParamsOpen: true,
        activeInputParamsId: id
      })
    }
    case inputParamsCustomInsightActions.ON_CHANGE_INPUT_PARAMS: {
      if(state.inputParams?.[action.name]?.[action.field] !== action.value) {
        return ReduxService.updateObject(state, { 
          inputParams: ReduxService.updateObject(state.inputParams || {}, { 
            [action.name]: ReduxService.updateObject(state.inputParams?.[action.name] || {}, { [action.field]: action.value })
          }) 
        })
      }
      return state;
    }
    case inputParamsCustomInsightActions.ON_CHANGE_INPUT_PARAMS_CONFIG: {
      if(state.content.inputParams?.[action.inputId]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { 
            inputParams: ReduxService.updateObject(state.content.inputParams, { 
              [action.inputId]: ReduxService.updateObject(state.content.inputParams[action.inputId], {
                [action.name]: action.value
              })
            })
          })
        })
      }
      return state;
    }
    case inputParamsCustomInsightActions.ON_ADD_INPUT_PARAMS_LIST:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: ReduxService.updateObject(state.content.inputParams, {
            [action.inputId]: ReduxService.updateObject(state.content.inputParams[action.inputId], {
              [action.listName]: state.content.inputParams[action.inputId][action.listName].add(action.item)
            })
          }) 
        })
      })
    case inputParamsCustomInsightActions.ON_CHANGE_INPUT_PARAMS_LIST: {
      if(state.content.inputParams?.[action.inputId]?.[action.listName]?.[action.listIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { 
            inputParams: ReduxService.updateObject(state.content.inputParams, {
              [action.inputId]: ReduxService.updateObject(state.content.inputParams[action.inputId], {
                [action.listName]: state.content.inputParams[action.inputId][action.listName].updateInList({ [action.name]: action.value }, action.listIndex)
              })
            }) 
          })
        })
      }
      return state;
    }
    case inputParamsCustomInsightActions.ON_REMOVE_INPUT_PARAMS_LIST: {
      const inputConfig = state.content.inputParams[action.inputId],
            indexes = Array.from({ length: inputConfig[action.listName].length }, (_, index) => index).filter(index => index !== action.listIndex),
            presets = action.listName === 'values' && inputConfig.presets
              ? { presets: remapScopeFilterValues({ presets: inputConfig.presets, indexes }) }
              : {}
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          inputParams: ReduxService.updateObject(state.content.inputParams, {
            [action.inputId]: ReduxService.updateObject(inputConfig, {
              [action.listName]: inputConfig[action.listName].remove(action.listIndex),
              ...presets
            })
          }) 
        })
      })
    }
    case inputParamsCustomInsightActions.ON_CHANGE_INPUT_PARAMS_USER_SELECTION: {
      if(state.inputParamsUserSelection[action.inputId]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          inputParamsUserSelection: ReduxService.updateObject(state.inputParamsUserSelection, {
            [action.inputId]: ReduxService.updateObject(state.inputParamsUserSelection[action.inputId] || {}, {
              [action.name]: action.value,
              ...(['symbols', 'filters', 'fileColumns'].includes(action.name) ? { [basicCustomInsightConsts.INPUT_PARAMS_SCOPE_PRESET_FIELDS.SELECTION]: undefined } : {})
            })
          }) 
        })
      }
      return state;
    }
    case inputParamsCustomInsightActions.IMPORT_INPUT_PARAMS_REPLACE_TILE: {
      const { oldId, newId, config } = action
      const inputParams = state.content.inputParams
      if (!inputParams?.[oldId]) {
        return state
      }
      const newInputParams = { ...inputParams }
      delete newInputParams[oldId]
      newInputParams[newId] = config
      return ReduxService.updateObject(state, {
        content: ReduxService.updateObject(state.content, {
          inputParams: newInputParams
        }),
        selectedTile: basicCustomInsightConsts.TILE_TYPES.INPUT_PARAMS + "-" + newId,
        activeInputParamsId: newId,
        isActiveInputParamsOpen: true
      })
    }
    default:
      return undefined;
  }
}
